import { AdminPermission, DashboardPermission, DriverApplicationPermission, DriverPermission, Module, OrderPermission, Pages, TransactionPermission, UserPermission, VehicleTypePermission, RolePermission as RolePermissionEnum, PushNotificationPermission, FarePermission, BannerPermission, VideoPermission, QuizPermission, WithdrawalPermission, DriverTierPermission } from "../shared/enums";
import { MdAnalytics, MdChat, MdDashboard, MdMap, MdOutlineOndemandVideo, MdQuiz } from "react-icons/md";
import {
  FaUserTie,
  FaCar,
  FaUserShield,
  FaUser,
  FaFilePen,
  FaMoneyBillTransfer,
  FaFileInvoiceDollar,
  FaUserLock,
  FaChalkboard,
  FaClipboardCheck,
  FaMoneyCheckDollar,
  FaGear
} from "react-icons/fa6";
import { TbSpeakerphone } from "react-icons/tb";
import { GrConfigure } from "react-icons/gr";
import Dashboard from "../pages/dashboard";
import Login from "../pages/auth/login";
import Admin from "../pages/admin";
import AdminDetail from "../pages/admin/detail";
import User from "../pages/user";
import UserDetail from "../pages/user/detail";
import UserForm from "../pages/user/form";
import VehicleType from "../pages/vehicleType";
import VehicleTypeDetail from "../pages/vehicleType/detail";
import DriverApplication from "../pages/driver-application";
import DriverApplicationDetail from "../pages/driver-application/detail";
import Driver from "../pages/driver";
import DriverDetail from "../pages/driver/detail";
import Transaction from "../pages/transaction";
import Order from "../pages/order";
import OrderDetail from "../pages/order/detail";
import RolePermission from "../pages/role-permission";
import SystemSetting from "../pages/system-settings";
import Broadcast from "../pages/broadcast";
import Banner from "../pages/banner";
import BannerDetail from "../pages/banner/detail";
import Video from "../pages/video";
import VideoDetail from "../pages/video/detail";
import Quiz from "../pages/quiz";
import QuizDetail from "../pages/quiz/detail";
import Attemp from "../pages/attemp";
import AttempDetail from "../pages/attemp/detail";
import Withdrawal from "../pages/withdrawal";
import Chat from "../pages/chat";
import Map from "../pages/map";
import DriverForm from "../pages/driver/form";
import Audit from "../pages/audit";
import DriverTier from "../pages/driver-tier";
import DriverTierDetail from "../pages/driver-tier/detail";

export { default as RouteValidation } from "./routeValidation";
export const routes = [
  {
    path: Pages.Default,
    element: <Dashboard />,
    isProtected: true,
    layout: true,
    menu: {
      icon: <MdDashboard />,
      label: "DASHBOARD",
      selected: [Pages.Default],
    },
    protection: [{
      module: Module.DASHBOARD,
      permission: DashboardPermission.READ
    }]
  },
  {
    path: Pages.Login,
    element: <Login />,
    isProtected: false,
    layout: false,
  },
  {
    path: Pages.Admin,
    element: <Admin />,
    isProtected: true,
    layout: true,
    menu: {
      icon: <FaUserShield />,
      label: "ADMIN",
      selected: [Pages.Admin, Pages.AdminDetail],
    },
    protection: [{
      module: Module.ADMIN,
      permission: AdminPermission.LIST
    }]
  },
  {
    path: Pages.AdminDetail,
    element: <AdminDetail />,
    isProtected: true,
    layout: true,
    protection: [{
      module: Module.ADMIN,
      permission: AdminPermission.READ
    }]
  },
  {
    path: "",
    menu: {
      label: "DRIVER",
      icon: <FaUserTie />,
      children: [
        {
          path: Pages.Driver,
          menu: {
            label: "DRIVER",
            icon: <FaUserTie />,
            selected: [Pages.Driver, Pages.DriverDetail],
          },
          protection: [
            {
              module: Module.DRIVER,
              permission: DriverPermission.LIST
            }
          ]
        },
        {
          path: Pages.DriverApplication,
          menu: {
            label: "DRIVER_APPLICATION",
            icon: <FaFilePen />,
            selected: [Pages.DriverApplication, Pages.DriverApplicationDetail],
          },
          protection: [
            {
              module: Module.DRIVER_APPLICATION,
              permission: DriverApplicationPermission.LIST
            }
          ]
        },
        {
          path: Pages.DriverTier,
          menu: {
            label: "DRIVER_TIER",
            icon: <FaClipboardCheck />,
            selected: [Pages.DriverTier, Pages.DriverTierDetail],
          },
          protection: [
            {
              module: Module.DRIVER_TIER,
              permission: DriverTierPermission.LIST
            }
          ]
        },
      ],
    },
    protection: [
      {
        module: Module.DRIVER,
        permission: DriverPermission.LIST
      },
      {
        module: Module.DRIVER_APPLICATION,
        permission: DriverApplicationPermission.LIST
      },
      {
        module: Module.DRIVER_TIER,
        permission: DriverTierPermission.LIST
      }
    ]
  },
  {
    path: Pages.Driver,
    element: <Driver />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.DRIVER,
        permission: DriverPermission.LIST
      },
    ]
  },
  {
    path: Pages.DriverDetail,
    element: <DriverDetail />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.DRIVER,
        permission: DriverPermission.READ
      },
    ]
  },
  {
    path: Pages.DriverForm,
    element: <DriverForm />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.DRIVER,
        permission: DriverPermission.READ
      },
    ]
  },
  {
    path: Pages.DriverApplication,
    element: <DriverApplication />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.DRIVER_APPLICATION,
        permission: DriverApplicationPermission.LIST
      }
    ]
  },
  {
    path: Pages.DriverApplicationDetail,
    element: <DriverApplicationDetail />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.DRIVER_APPLICATION,
        permission: DriverApplicationPermission.READ
      }
    ]
  },
  {
    path: Pages.DriverTier,
    element: <DriverTier />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.DRIVER_TIER,
        permission: DriverTierPermission.LIST
      }
    ]
  },
  {
    path: Pages.DriverTierDetail,
    element: <DriverTierDetail />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.DRIVER_TIER,
        permission: DriverTierPermission.READ
      }
    ]
  },
  {
    path: Pages.User,
    element: <User />,
    isProtected: true,
    layout: true,
    menu: {
      icon: <FaUser />,
      label: "USER",
      selected: [Pages.User, Pages.UserForm, Pages.UserDetail, Pages.UserWallet],
    },
    protection: [
      {
        module: Module.USER,
        permission: UserPermission.LIST
      }
    ]
  },
  {
    path: Pages.UserForm,
    element: <UserForm />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.USER,
        permission: UserPermission.CREATE
      },
      {
        module: Module.USER,
        permission: UserPermission.UPDATE
      }
    ]
  },
  {
    path: Pages.UserDetail,
    element: <UserDetail />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.USER,
        permission: UserPermission.READ
      }
    ]
  },
  {
    path: "",
    menu: {
      label: "WITHDRAWAL",
      icon: <FaMoneyCheckDollar />,
      children: [
        {
          path: Pages.WithdrawalDriver,
          menu: {
            label: "DRIVER",
            icon: <FaUserTie />,
            selected: [Pages.WithdrawalDriver],
          },
          protection: [
            {
              module: Module.WITHDRAWAL,
              permission: WithdrawalPermission.LIST
            }
          ],
        },
        {
          path: Pages.WithdrawalUser,
          menu: {
            label: "USER",
            icon: <FaUser />,
            selected: [Pages.WithdrawalUser],
          },
          protection: [
            {
              module: Module.WITHDRAWAL,
              permission: WithdrawalPermission.LIST
            }
          ],
        },
      ],
    },
    protection: [
      {
        module: Module.WITHDRAWAL,
        permission: WithdrawalPermission.LIST
      }
    ]
  },
  {
    path: Pages.WithdrawalDriver,
    element: <Withdrawal role={"driver"} />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.WITHDRAWAL,
        permission: WithdrawalPermission.LIST
      },
    ]
  },
  {
    path: Pages.WithdrawalUser,
    element: <Withdrawal role={"user"} />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.WITHDRAWAL,
        permission: WithdrawalPermission.LIST
      },
    ]
  },
  {
    path: Pages.VehicleType,
    element: <VehicleType />,
    isProtected: true,
    layout: true,
    menu: {
      icon: <FaCar />,
      label: "VEHICLE_TYPE",
      selected: [Pages.VehicleType, Pages.VehicleTypeDetail],
    },
    protection: [
      {
        module: Module.VEHICLE_TYPE,
        permission: VehicleTypePermission.LIST
      }
    ]
  },
  {
    path: Pages.VehicleTypeDetail,
    element: <VehicleTypeDetail />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.VEHICLE_TYPE,
        permission: VehicleTypePermission.READ
      }
    ]
  },
  {
    path: Pages.Transaction,
    element: <Transaction />,
    isProtected: true,
    layout: true,
    menu: {
      icon: <FaMoneyBillTransfer />,
      label: "TRANSACTION",
      selected: [Pages.Transaction],
    },
    protection: [
      {
        module: Module.TRANSACTION,
        permission: TransactionPermission.LIST
      }
    ]
  },
  {
    path: Pages.Order,
    element: <Order />,
    isProtected: true,
    layout: true,
    menu: {
      icon: <FaFileInvoiceDollar />,
      label: "ORDER",
      selected: [Pages.Order, Pages.OrderDetail],
    },
    protection: [
      {
        module: Module.ORDER,
        permission: OrderPermission.LIST
      }
    ]
  },
  {
    path: Pages.OrderDetail,
    element: <OrderDetail />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.ORDER,
        permission: OrderPermission.READ
      }
    ]
  },
  {
    path: Pages.Banner,
    element: <Banner />,
    isProtected: true,
    layout: true,
    menu: {
      icon: <FaChalkboard />,
      label: "BANNER",
      selected: [Pages.Banner, Pages.BannerDetail],
    },
    protection: [
      {
        module: Module.BANNER,
        permission: BannerPermission.LIST
      }
    ]
  },
  {
    path: Pages.BannerDetail,
    element: <BannerDetail />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.BANNER,
        permission: BannerPermission.READ
      }
    ]
  },
  {
    path: Pages.Video,
    element: <Video />,
    isProtected: true,
    layout: true,
    menu: {
      icon: <MdOutlineOndemandVideo />,
      label: "VIDEO",
      selected: [Pages.Video, Pages.VideoDetail],
    },
    protection: [
      {
        module: Module.VIDEO,
        permission: VideoPermission.LIST
      }
    ]
  },
  {
    path: Pages.VideoDetail,
    element: <VideoDetail />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.VIDEO,
        permission: VideoPermission.READ
      }
    ]
  },
  {
    path: Pages.Broadcast,
    element: <Broadcast />,
    isProtected: true,
    layout: true,
    menu: {
      icon: <TbSpeakerphone />,
      label: "BROADCAST",
      selected: [Pages.Broadcast],
    },
    protection: [
      {
        module: Module.PUSH_NOTIFICATION,
        permission: PushNotificationPermission.LIST
      }
    ]
  },
  {
    path: Pages.Attempt,
    element: <Attemp />,
    isProtected: true,
    layout: true,
    menu: {
      icon: <FaClipboardCheck />,
      label: "ATTEMPT",
      selected: [Pages.Attempt, Pages.AttemptDetail],
    },
    protection: [
      {
        module: Module.QUIZ,
        permission: QuizPermission.LIST
      }
    ]
  },
  {
    path: Pages.AttemptDetail,
    element: <AttempDetail />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.QUIZ,
        permission: QuizPermission.READ
      }
    ]
  },
  {
    path: "",
    menu: {
      label: "CONFIGURATION",
      icon: <GrConfigure />,
      children: [
        {
          path: Pages.Quiz,
          element: <Quiz />,
          isProtected: true,
          layout: true,
          menu: {
            icon: <MdQuiz />,
            label: "QUIZ",
            selected: [Pages.Quiz, Pages.QuizDetail],
          },
          protection: [
            {
              module: Module.QUIZ,
              permission: QuizPermission.LIST
            }
          ]
        },
        {
          path: Pages.RolePermission,
          menu: {
            label: "ROLE_PERMISSION",
            icon: <FaUserLock />,
            selected: [Pages.RolePermission],
          },
          protection: [
            {
              module: Module.ROLE,
              permission: RolePermissionEnum.LIST
            }
          ]
        },
        {
          path: Pages.SystemSetting,
          menu: {
            label: "SYSTEM_SETTING",
            icon: <FaGear />,
            selected: [Pages.SystemSetting],
          },
          protection: [
            {
              module: Module.SYSTEM_SETTING,
              permission: RolePermissionEnum.LIST
            }
          ]
        },
      ],
    },
    protection: [
      {
        module: Module.ROLE,
        permission: RolePermissionEnum.LIST
      },
      {
        module: Module.SYSTEM_SETTING,
        permission: RolePermissionEnum.LIST
      },
      {
        module: Module.FARE,
        permission: FarePermission.LIST
      }
    ]
  },
  {
    path: Pages.RolePermission,
    element: <RolePermission />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.ROLE,
        permission: RolePermissionEnum.LIST
      }
    ]
  },
  {
    path: Pages.SystemSetting,
    element: <SystemSetting />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.SYSTEM_SETTING,
        permission: RolePermissionEnum.LIST
      }
    ]
  },
  {
    path: Pages.Quiz,
    element: <Quiz />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.QUIZ,
        permission: QuizPermission.LIST
      }
    ]
  },
  {
    path: Pages.QuizDetail,
    element: <QuizDetail />,
    isProtected: true,
    layout: true,
    protection: [
      {
        module: Module.QUIZ,
        permission: QuizPermission.READ
      }
    ]
  },
  {
    path: Pages.Chat,
    element: <Chat />,
    isProtected: true,
    layout: true,
    menu: {
      icon: <MdChat />,
      label: "CHAT",
      selected: [Pages.Chat],
    },
    protection: [{
      module: Module.ADMIN,
      permission: AdminPermission.READ
    }]
  },
  {
    path: Pages.Map,
    element: <Map />,
    isProtected: true,
    layout: true,
    menu: {
      icon: <MdMap />,
      label: "MAP",
      selected: [Pages.Map],
    },
    protection: [{
      module: Module.ADMIN,
      permission: AdminPermission.READ
    }]
  },
  {
    path: Pages.Audit,
    element: <Audit />,
    isProtected: true,
    layout: true,
    menu: {
      icon: <MdAnalytics />,
      label: "AUDIT",
      selected: [Pages.Audit],
    },
    protection: [{
      module: Module.AUDIT,
      permission: AdminPermission.READ
    }]
  },
];
